export default "__VITE_ASSET__7cf7c68f__"